<script setup>
import PageLink from "@/Components/PageLink.vue";
import { cn, getEventDate } from "../lib/utils.js";
import { Link } from "@inertiajs/vue3";

const { event } = defineProps({
  event: {
    type: Object,
    required: true,
  },
  showDescription: {
    type: Boolean,
    default: false,
  },
  innerCss: {
    type: String,
    default: "",
  },
  bottomCss: {
    type: String,
    default: "",
  },
  descriptionCss: {
    type: String,
    default: "",
  },
  type: {
    type: String,
    default: "upcoming-event",
  },
});
</script>

<template>
  <div
    :class="`event-type-${event.type}`"
    class="event--card group relative box-border before:content-[''] before:block before:pt-[87%]"
  >
    <Link
      class="h-auto w-full box-border px-3 lg:px-6 absolute top-0 left-0 aspect-[1/0.87]"
      :class="innerCss"
      :href="event.url"
    >
      <div
        :style="{ backgroundColor: event.color }"
        class="h-full w-full relative"
      >
        <div class="px-3 pt-3 w-full uppercase font-sans">
          {{ getEventDate(event) }}
        </div>
        <div class="px-3 absolute top-1/2 -translate-y-1/2">
          <h3>{{ event.title }}</h3>
        </div>
        <div class="px-3 pb-2 w-full absolute left-0 bottom-0">
          <PageLink
            arrow-color="text-brand-dark-blue"
            :href="event.url"
            class="underline link-dark mt-auto mr-auto px-0 whitespace-normal h-auto"
          >
            <span>Earn CPD Points & Register Now</span>
          </PageLink>
        </div>
      </div>
    </Link>
    <div
      v-if="showDescription"
      :class="cn('w-full mt-3 lg:mt-6 px-3 lg:px-6 lg:mb-10', descriptionCss)"
    >
      <div :class="bottomCss">
        <span v-html="event.short_description"></span>
        <PageLink
          arrow-color="text-brand-dark-blue"
          :href="event.url"
          class="underline link-dark mt-3 lg:mt-6 mr-auto px-0"
        >
          Read more about this event
        </PageLink>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss"></style>
